/* esm.sh - @floating-ui/dom@1.7.6 */
export * from "/*@floating-ui/dom@1.7.6/esnext/dom.mjs";
